import React from 'react'

import DemoForm from '@toasttab/main/src/components/DemoForm/DemoForm'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'

const DemoRequest = ({ body }: { body: any }) => {
  return (
    <section className='relative before:content-[""] before:w-full before:h-full before:absolute before:bg-top-brand-50-gradient lg:before:bg-left-brand-50-gradient before:rounded-[1.5rem] lg:before:rounded-[3rem] before:top-0 mb-10 lg:mb-16 bg-cover bg-no-repeat bg-center bg-brand-50 bg-hp-brand-line-Mobile lg:bg-hp-brand-line-Desktop rounded-[1.5rem] lg:rounded-[3rem] py-6 lg:py-[4.5rem]'>
      <div className='ds-wrapper'>
        <div className='ds-container lg:ds-grid relative z-20'>
          <div className='col-span-4 lg:col-span-6 grid justify-center content-center px-6 lg:px-10 lg:max-w-[544px] z-20'>
            <Typography
              as='h2'
              variation='h2'
              classes='font-effra font-normal text-[3.313rem] leading-[4rem] mb-4 text-center text-primary text-white'
              allowHtml={false}
            >
              {body.columns.left.heading}
            </Typography>
            <Typography
              as='h4'
              variation='h4'
              classes='!font-effra !font-normal text-[1.375rem] mb-6 text-center text-secondary text-white'
              allowHtml={false}
            >
              {body.columns.left.description}
            </Typography>
            <img
              className='mb-6 lg:mb-0 justify-self-center'
              src={body.columns.left.assets.image.src}
              alt='G2 Winter 2025 Leader Award Winner'
            />
          </div>
          <div className='col-span-4 lg:col-span-6 lg:max-w-[544px] z-20'>
            <div className='bg-white rounded-[0.625rem] p-6 lg:p-8'>
              <Typography
                as='h3'
                variation='h3'
                classes='font-effra font-normal text-[2.688rem] leading-[3rem] mb-6 text-primary'
                allowHtml={false}
              >
                {body.columns.right.form.heading}
              </Typography>
              <DemoForm
                formData={body.columns.right.form.data}
                fieldIdPrefix='ContentfulHomePageDemoRequest'
                heapInteractionSubmit='hprefine_bottomdemoMQL_submit'
                privacyStatementCenter={false}
                useRecaptcha={false}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default DemoRequest
